export default __webpack_public_path__ + "static/media/Girdle of Writhing.2203624e.jpg";